function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "MapIcon");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-map",
  transform: "translate(-2.000000, -3.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M21.32,5.04999999 L15.32,3.04999999 L15.25,3.04999999 C15.2034506,3.0453216 15.1565494,3.0453216 15.11,3.04999999 L14.88,3.04999999 L14.75,3.04999999 L14.68,3.04999999 L8.99999663,4.99999999 L3.31999999,3.04999999 C3.01492701,2.94940422 2.68010071,3.00148831 2.41999999,3.18999999 C2.15780442,3.37667582 2.0014883,3.67814262 1.99999663,3.99999999 L1.99999663,18 C1.99889023,18.4299159 2.27268827,18.8124279 2.67999999,18.95 L8.68,20.95 L8.68,20.95 C8.88144755,21.0156846 9.09855244,21.0156846 9.3,20.95 L9.3,20.95 L14.9999966,19.05 L20.68,21 C20.7861802,21.0144072 20.8938198,21.0144072 20.9999966,21 C21.2090848,21.0029409 21.4131812,20.9360817 21.58,20.81 C21.8421956,20.6233242 21.9985117,20.3218574 21.9999966,20 L21.9999966,5.99999999 C22.0011098,5.57008408 21.7273117,5.18757211 21.32,5.04999999 Z M7.99999999,18.61 L3.99999999,17.28 L3.99999999,5.38999999 L7.99999999,6.71999999 L7.99999999,18.61 Z M14,17.28 L10,18.61 L10,6.71999999 L14,5.38999999 L14,17.28 Z M20,18.61 L16,17.28 L16,5.38999999 L20,6.71999999 L20,18.61 Z",
  id: "MapIcon"
})));

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map.8e978da0.svg";
export { ForwardRef as ReactComponent };